import { ChangeDetectorRef, DestroyRef, Directive, ElementRef, EventEmitter, HostListener, inject, Input, Output } from '@angular/core';

@Directive({
  selector: '[stHorizontalScrollDetection]',
  standalone: true
})
export class HorizontalScrollDetectionDirective {
  @Output() hasHorizontalScroll = new EventEmitter<boolean>();
  @Input() set breakpoint(value: number | undefined) {
    if(value){
      this._breakpoint = value ? value * 165 : 0;
      this.checkScrollWidth()
    }
  }

  readonly #destroyRef = inject(DestroyRef);


  private lastScrollState: boolean = false;
  private resizeObserver: ResizeObserver | null = null;
  private _breakpoint = 0


  constructor(
    readonly el: ElementRef,
    readonly cdr: ChangeDetectorRef
  ) { }

  ngAfterViewInit() {
    // Use ResizeObserver to detect changes in dimensions
    this.resizeObserver = new ResizeObserver(() => {
      this.checkScrollWidth();
    });
    this.resizeObserver.observe(this.el.nativeElement);

    // Initial check with ChangeDetectorRef to wait until DOM is stable
    this.cdr.detectChanges();
    this.#destroyRef.onDestroy(() => {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    });
  }


  @HostListener('window:resize')
  onResize() {
    this.checkScrollWidth();
  }

  private checkScrollWidth() {
    const element = this.el.nativeElement;
    const isScrollable = this._breakpoint > element.clientWidth;

    // Emit the event only if the scroll state has changed
    if (isScrollable !== this.lastScrollState) {
      this.lastScrollState = isScrollable;
      this.hasHorizontalScroll.emit(isScrollable);
    }
  }
}